import { render, staticRenderFns } from "./FailuresList.vue?vue&type=template&id=9365ea10&scoped=true&"
import script from "./FailuresList.vue?vue&type=script&lang=js&"
export * from "./FailuresList.vue?vue&type=script&lang=js&"
import style0 from "./FailuresList.vue?vue&type=style&index=0&id=9365ea10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9365ea10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VCol,VList,VListItem,VListItemContent,VListItemTitle,VRow,VSpacer,VTooltip})
